export default "__VITE_ASSET__DrBmJ5Hh__"